module.exports = __webpack_public_path__ + "31fa0efe69587d62305133c4223a1f08.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/intro-panel-texture-768.webp.png
// module id = 418
// module chunks = 0